import { ready } from '../helpers/jQueryReplacements';

ready(() => {
  const $addButton = $('#contacts-add-button');
  const $totalFormsCounter = $('#id_form-TOTAL_FORMS');
  const $formRegex = RegExp('form-(\\d+|__prefix__){1}', 'g');
  const $templateForm = $('#contacts-form-000');

  /*
  Simple function to quickly set/unset the name and email fields of a form
  as required. By design, we are not making phone numbers required.
  */
  const makeRequired = (form, required) => {
    const $name = $(form.find('input[id*="-name"]')[0]);
    const $email = $(form.find('input[id*="-email"]')[0]);
    $name.prop('required', required);
    $email.prop('required', required);
  };

  const addSanitizer = (form) => {
    const $name = $(form.find('input[id*="-name"]')[0]);
    const $email = $(form.find('input[id*="-email"]')[0]);
    // add focus off event to trim whitespace when leaving field
    $name.on('focusout', () => {
      $name.val($name.val().trim());
    });
    $email.on('focusout', () => {
      $email.val($email.val().trim());
    });
  };

  // Mark the initial forms as required
  const $initialForms = $('.press-contacts__form[id*=contacts-form-]').slice(0, -1);
  $initialForms.each((index, value) => {
    makeRequired($(value), true);
    addSanitizer($(value));
  });

  /*
  Change the form headers to the proper number in order, but only if visible.
  By design, we want to omit the header for the first visible form.
  Additionally, we want to hide the add button to communicate to users
  that they may only publish a maximum of 5 press contacts.
  */
  const reindexAndCheckNumVisible = () => {
    const $forms = $('.press-contacts__form[id*=contacts-form-]').slice(0, -1);
    let $visibleCounter = 0;

    $forms.each((index, value) => {
      const $header = $(value).find('.press-contacts__form__header');
      let $sameAsPrimaryCheckbox = $(value).find('.press-contacts__form__same-as-primary-checkbox');
      // Update the header and 'same as primary contact' checkbox values
      // for the first visible contact
      if ($(value).is(':visible')) {
        $visibleCounter += 1;
        if ($visibleCounter === 1) {
          $header.text('');
          $sameAsPrimaryCheckbox.show();
        } else {
          $header.text(`Press contact #${$visibleCounter}`);
          $sameAsPrimaryCheckbox.hide();
        }
      }

      // Update the management-form-generated indexes; these will always go in order from 0
      // Keep a record of the currently typed value so that customers' input will not be
      // lost when the reindex occurs
      $(value).attr('id', `contacts-form-${index}`);
      const $nameCurrentValue = $($(value).find('input[id*="-name"]')[0]).val();
      const $emailCurrentValue = $($(value).find('input[id*="-email"]')[0]).val();
      const $phoneNumberCurrentValue = $($(value).find('input[id*="-phone_number"]')[0]).val();
      $(value).html($(value).html().replace($formRegex, `form-${index}`));
      $($(value).find('input[id*="-name"]')[0]).attr('value', $nameCurrentValue);
      $($(value).find('input[id*="-email"]')[0]).attr('value', $emailCurrentValue);
      $($(value).find('input[id*="-phone_number"]')[0]).attr('value', $phoneNumberCurrentValue);

      // Bind the replacement html to the delete function
      const $deleteButton = $(value).find('.press-contacts__form__delete');
      // eslint-disable-next-line no-use-before-define
      $deleteButton.click(() => deleteForm($deleteButton.attr('value')));

      // Bind the checkbox to its change event after IDs have been updated
      $sameAsPrimaryCheckbox = $(value).find('.press-contacts__form__same-as-primary-checkbox');
      const $checkboxInput = $sameAsPrimaryCheckbox.find('input[type=checkbox][name=same-as-primary]');
      const $checkboxId = $checkboxInput.attr('id');
      $(document).off('change', `input[type=checkbox][name="same-as-primary"][id="${$checkboxId}"]`);
      $(document).on('change', `input[type=checkbox][name="same-as-primary"][id="${$checkboxId}"]`, function() {
        // get reference to the error message informing the user that
        // contact info is required to use 'Same As Contact Information'
        const $sameAsPrimaryErrorMessage = $($(value).find('.contact-info-required-error-message')[0]);
        if ($(this).prop('checked')) {
          const $primaryName = $('input[id="id_submitter_name"]').val();
          const $primaryEmail = $('input[id="id_submitter_email"]').val();
          if (!$primaryName || !$primaryEmail) {
            $(this).prop('checked', false);
            $sameAsPrimaryErrorMessage.show(); // Show contact info error
          } else {
            const $nameField = $($(value).find('input[id*="-name"]')[0]);
            const $emailField = $($(value).find('input[id*="-email"]')[0]);
            $nameField.val($primaryName);
            $nameField.prop('readonly', true);
            $nameField.css({ 'background-color': '#f5f5fa', cursor: 'default' }); // $dive-grey-1
            $emailField.val($primaryEmail);
            $emailField.prop('readonly', true);
            $emailField.css({ 'background-color': '#f5f5fa', cursor: 'default' }); // $dive-grey-1
            $sameAsPrimaryErrorMessage.hide(); // Hide contact info error
          }
        } else {
          const $nameField = $($(value).find('input[id*="-name"]')[0]);
          const $emailField = $($(value).find('input[id*="-email"]')[0]);
          $nameField.val('');
          $nameField.prop('readonly', false);
          $nameField.css({ 'background-color': '', cursor: 'text' });
          $emailField.val('');
          $emailField.prop('readonly', false);
          $emailField.css({ 'background-color': '', cursor: 'text' });
        }
      });
      addSanitizer($(value));
    });

    // Per design, if 5 press contacts are currently visible, hide the add button
    if ($visibleCounter >= 5) {
      $addButton.hide();
    } else {
      $addButton.show();
    }
  };

  /*
  Check if the deletion marker is available (only validates on pre-existing contacts).
  If so, mark it and hide the form since we still want to submit it.
  Otherwise, delete the form; this makes save validation simpler,
  and protects us against potential bot attacks.
  */
  const deleteForm = (formId) => {
    const $targetForm = $(`#${formId}`);
    const $deleteCheck = $targetForm.find('input[id*=-DELETE]');

    // If a delete marker exists, mark the form and hide it instead of removing
    // Note that we use attr() instead of prop() here; we specifically need for
    // 'checked' to be represented as an attribute
    if ($deleteCheck.length) {
      $deleteCheck.attr('checked', true);
      $targetForm.hide();
      makeRequired($targetForm, false);
    } else {
      $targetForm.remove();
      $totalFormsCounter.val(parseInt($totalFormsCounter.val(), 10) - 1);
    }

    reindexAndCheckNumVisible();
  };

  /*
  Using the empty_form template provided by the formset, generate a new form and
  add it to the formset. This will differ slightly from the ones created from
  existing data.
  */
  const addForm = () => {
    // Create a clone of the template form
    const $newForm = $templateForm.clone(true);

    // Insert the new form and update hidden management form data
    $newForm.insertBefore($addButton);
    makeRequired($newForm, true);
    $newForm.show();
    $totalFormsCounter.val(parseInt($totalFormsCounter.val(), 10) + 1);

    reindexAndCheckNumVisible();
  };

  $addButton.click(() => addForm());

  // Add listeners for initial form delete buttons
  $('[class=press-contacts__form__delete]').each((index, value) => {
    $(value).click(() => deleteForm($(value).attr('value')));
  });
});
